import { createMuiTheme, fade } from '@material-ui/core/styles';
import common from '@material-ui/core/colors/common';

export const BREAKPOINTS_VALUES = {
  xs: 0,
  sm: 500,
  md: 800,
  lg: 1100,
  xl: 1200,
  ml: 2200,
};
export const colorsPalette = {
  black: '#00000066',
  blackPure: '#000000',
  blackSecondary: '#23202E',
  white: '#ffffff',
  whiteSecondary: 'rgba(255,255,255,.15)',
  gray: '#C9C4D4',
  graySecondary: '#F2F4F5',
  graySaturated: '#828282',
  grayLight: '#c8c3d4',
  grayThird: '#BEBAC9',
  blue: '#6869ED',
  blueDark: '#1b1925',
  blueLight: '#20A4F3',
  violet: '#8686f1',
  violetSecondary: '#a2a4ee',
  violetDark: '#22202D',
  violetAnalyticsToggle: '#4C4663',
  violetAnalyticsCard: '#2D293B',
  iconViolet: '#353359',
  turquoiseLight: '#a6fff6',
  red: '#ff0000',
  blueProgressBar: '#5A6EED',
  primary: '#7EFCF0',
  pink: '#E5BFEE',
  green: '#86E380',
  error: '#CA062E',
  errorLight: '#FB6382',
  failedError: '#D86B67',
  loadingAnimation: '#49445E',
  yellow: '#E6FB7A',
  coral: '#F45B69',
  linkedInBlue: '#0077B7',
};

export const INNER_BOTTOM_SPACE_DESK = 36;

export const SMALL_MARGIN = 18;
export const MIDDLE_MARGIN = 36;
export const BIG_MARGIN = 54;
export const LARGE_MARGIN = 72;

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      light: '#7EFCF0',
      main: '#7EFCF0',
      dark: '#7EFCF0',
      contrastText: common.black,
    },
    secondary: {
      light: '#23202E',
      main: '#23202E',
      dark: '#1B1925',
      contrastText: common.white,
    },
  },
  typography: {
    fontFamily: '"sofia-pro", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  breakpoints: { values: BREAKPOINTS_VALUES },
  overrides: {},
});

if (theme.overrides) {
  theme.overrides.MuiContainer = {
    root: {
      [theme.breakpoints.up('sm')]: {
        paddingLeft: 16,
        paddingRight: 16,
      },
      [theme.breakpoints.up('md')]: {
        paddingLeft: 24,
        paddingRight: 24,
      },
      [theme.breakpoints.up('xl')]: {
        paddingLeft: 16,
        paddingRight: 16,
      },
    },
    maxWidthLg: {
      [theme.breakpoints.up('sm')]: {
        maxWidth: 1200,
      },
    },
  };

  // @ts-ignore
  theme.overrides.MuiAlert = {
    filledSuccess: {
      color: 'rgba(0, 0, 0, 0.87)',
      backgroundColor: '#7EFCF0',
    },
  };

  theme.overrides.MuiTabs = {
    flexContainer: {
      borderBottom: '2px solid rgba(134, 134, 241, 0.301961)',
    },
    indicator: {
      backgroundColor: `${colorsPalette.violet}`,
    },
  };

  theme.overrides.MuiTab = {
    root: {
      minWidth: 0,
      marginRight: 15,

      [theme.breakpoints.up('sm')]: {
        minWidth: 0,
      },
    },
    wrapper: {
      fontSize: 20,
      fontWeight: 'bold',
      textTransform: 'none',
    },
  };

  theme.overrides.MuiSelect = {
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  };
  theme.overrides.MuiList = {
    root: {
      background: colorsPalette.violetAnalyticsCard,
    },
  };
  theme.overrides.MuiOutlinedInput = {
    root: {
      borderRadius: 8,
      borderColor: fade(colorsPalette.white, 0.33),
      '&$focused $notchedOutline': {
        borderColor: colorsPalette.blue,
        borderWidth: 1,
      },
      '&$error $notchedOutline': {
        borderColor: colorsPalette.errorLight,
      },
      '&:hover $notchedOutline': {
        borderColor: colorsPalette.blue,
      },
    },
    input: {
      color: colorsPalette.gray,
      fontSize: 18,
      lineHeight: '26px',
      padding: '18px 16px',
      '&:-webkit-autofill': {
        color: colorsPalette.gray,
        '-webkit-box-shadow': `0 0 0 100px ${colorsPalette.violetAnalyticsCard} inset`,
      },
    },
    notchedOutline: {
      '& legend': {
        fontSize: 14,
      },
    },
    adornedEnd: {
      paddingRight: 7,
    },
  };
  theme.overrides.MuiInputLabel = {
    root: {
      color: fade(colorsPalette.white, 0.33),
      fontSize: 18,
      lineHeight: '26px',
      '&$focused': {
        color: colorsPalette.blue,
      },
      '&$error': {
        color: colorsPalette.error,
      },
    },
    outlined: {
      transform: 'translate(14px, 16px) scale(1)',
      '&$shrink': {
        transform: 'translate(14px, -10px) scale(0.75)',
      },
    },
  };
  theme.overrides.MuiFormHelperText = {
    root: {
      '&$error': {
        color: colorsPalette.error,
      },
    },
  };
  //@ts-ignore
  theme.overrides.MuiAutocomplete = {
    clearIndicator: {
      display: 'none',
    },
    popupIndicator: {
      color: fade(colorsPalette.white, 0.33),
    },
    popupIndicatorOpen: {
      color: colorsPalette.blue,
    },
    paper: {
      margin: 0,
      backgroundColor: [theme.palette.secondary.light],
    },
    option: {
      fontSize: 18,
      lineHeight: '26px',
      color: colorsPalette.gray,
      padding: '16px 8px',
      '&[data-focus="true"]': {
        backgroundColor: colorsPalette.violetAnalyticsCard,
      },
    },
  };
  //@ts-ignore
  theme.overrides.MuiPickersBasePicker = {
    pickerView: {
      backgroundColor: [theme.palette.secondary.light],
    },
  };
  theme.overrides.MuiPickersCalendarHeader = {
    iconButton: {
      backgroundColor: colorsPalette.violetAnalyticsCard,
    },
  };
  theme.overrides.MuiPickersDay = {
    day: {
      '&:hover': {
        backgroundColor: colorsPalette.violetAnalyticsCard,
      },
    },
  };
}

theme.typography.h1 = {
  fontSize: 32,
  lineHeight: '40px',
  fontWeight: 'bold',
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    fontSize: 40,
    lineHeight: 1.2,
    marginBottom: 0,
  },
};

theme.typography.h2 = {
  fontSize: 24,
  lineHeight: '29px',
  fontWeight: 'bold',
  marginBottom: 22,
  [theme.breakpoints.up('sm')]: {
    fontSize: 28,
    lineHeight: 1.2,
    marginBottom: 0,
  },
};

theme.typography.h3 = {
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 'bold',
  marginBottom: 8,
  [theme.breakpoints.up('sm')]: {
    fontSize: 24,
    lineHeight: 1.2,
    marginBottom: 0,
  },
};

theme.typography.h4 = {
  fontSize: 22,
  lineHeight: '22px',
  fontWeight: 'bold',
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    fontSize: 20,
    lineHeight: '22px',
    marginBottom: 0,
  },
};

export default theme;
